import {
    GET_DISTRIBUTORS_REPORTS,
    UPDATE_DISTRIBUTOR_REPORT
} from './finance.actionsTypes';
import  { ACTION_TYPES } from '../../config/constants';

const updateReports = (state, report) => {
    const newState = state.map((item) => {
        if (item._id === report._id || item.shopId === report.shopId) {
            Object.assign(item, report);
        }
        return item;
    });
    return newState;
};

export default function distributorsReports(state = [], action) {
    let newState = Object.assign(state);
    switch (action.type) {
        case GET_DISTRIBUTORS_REPORTS:
            return action.distributorReport;
        case UPDATE_DISTRIBUTOR_REPORT:
            return updateReports(newState, action.report);
        case ACTION_TYPES.LOGOUT_SUCCESS:
            return [];
        default:
            return newState;
    }
}